import React from "react";
import { useNavigate } from "react-router-dom";
import shareVedio from "../assets/share.mp4";
import logo from "../assets/logowhite.png";
import { GoogleLogin, googleLogout } from "@react-oauth/google";
import jwt_decode from "jwt-decode";
import { client } from "../client";


const Login = () => {

    const navigate = useNavigate();
    const createOrGetUser = (response) => {
      const decoded = jwt_decode(response.credential);
      console.log(decoded);
      localStorage.setItem("user", JSON.stringify(decoded));
      const { sub, name, picture } = decoded;
      const doc = {
        _id: sub,
        _type: "user",
        userName: name,
        image: picture,
      }

      client.createIfNotExists(doc)
        .then((res) => {
          navigate("/", { replace: true });
        })
    }


  return (
    <div className="flex justify-start items-center flex-col h-screen">
      <div className="relative w-full h-full">
        <video
          src={shareVedio}
          loop
          controls={false}
          autoPlay
          muted
          className="absolute w-full h-full object-cover"
        />

        <div className="absolute flex felx-col justify-center items-center top-0 left-0 right-0 bottom-0 bg-blackOverlay">
          <div className="p-5">
            <img src={logo} alt="logo" width = "130px"/>
          </div>

          <div className="shadow-2xl">
            <GoogleLogin
              onSuccess={(response) => 
              {
                createOrGetUser(response)
              }}
              onFailure={(response) => console.log(response)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
